import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import styles from './AuthForm.module.css';

export default function AuthForm({ mode }) {
  const isLogin = mode === 'login';
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({ name: '', email: '', password: '', phone: '' });
  const [error, setError] = useState(null);
  const [info] = useState(location.state?.info || null);
  const [loading, setLoading] = useState(false);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const endpoint = isLogin ? '/api/auth/login' : '/api/auth/register';
      const body = isLogin
        ? { email: form.email, password: form.password }
        : { name: form.name, email: form.email, password: form.password, phone: form.phone };

      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await res.json();

      if (!res.ok) {
        // konto niezweryfikowane → przekieruj do weryfikacji
        if (data.needsVerification) {
          navigate('/weryfikacja-email', { state: { email: data.email } });
          return;
        }
        throw new Error(data.error || 'Błąd serwera');
      }

      if (!isLogin) {
        // po rejestracji → strona weryfikacji
        navigate('/weryfikacja-email', { state: { email: form.email } });
        return;
      }

      login(data.token, data.user);
      navigate('/moje-ogloszenia');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <h1>{isLogin ? 'Zaloguj się' : 'Zarejestruj się'}</h1>
        <p className={styles.sub}>
          {isLogin ? 'Nie masz konta?' : 'Masz już konto?'}{' '}
          <Link to={isLogin ? '/rejestracja' : '/logowanie'}>
            {isLogin ? 'Zarejestruj się' : 'Zaloguj się'}
          </Link>
        </p>

        {info && <div className={styles.info}>{info}</div>}

        <form onSubmit={handleSubmit} className={styles.form}>
          {!isLogin && (
            <>
              <div className={styles.field}>
                <label>Imię i nazwisko *</label>
                <input required type="text" placeholder="Anna Kowalska" value={form.name} onChange={e => set('name', e.target.value)} />
              </div>
              <div className={styles.field}>
                <label>Telefon</label>
                <input type="tel" placeholder="+48 500 100 200" value={form.phone} onChange={e => set('phone', e.target.value)} />
              </div>
            </>
          )}
          <div className={styles.field}>
            <label>E-mail *</label>
            <input required type="email" placeholder="adres@email.pl" value={form.email} onChange={e => set('email', e.target.value)} />
          </div>
          <div className={styles.field}>
            <label>Hasło * {!isLogin && <span className={styles.hint}>(minimum 8 znaków)</span>}</label>
            <input required type="password" placeholder="••••••••" minLength={isLogin ? 1 : 8} value={form.password} onChange={e => set('password', e.target.value)} />
          </div>

          {isLogin && (
            <div className={styles.forgotWrap}>
              <Link to="/zapomniane-haslo" className={styles.forgot}>Zapomniałem/am hasła</Link>
            </div>
          )}

          {error && <div className={styles.error}>{error}</div>}

          <button type="submit" className={styles.submit} disabled={loading}>
            {loading ? 'Proszę czekać...' : isLogin ? 'Zaloguj się' : 'Zarejestruj się'}
          </button>
        </form>

        {isLogin && (
          <p className={styles.demo}>
            Konto demo: <strong>demo@nieruchomy.pl</strong> / <strong>demo1234</strong>
          </p>
        )}
      </div>
    </div>
  );
}
